import styled from "styled-components";

export const CancelButton = styled.button`
  background-color: #6c757d;
  color: white;
  border: none;
  padding: 10px 20px;
  margin-right: 10px;
  border-radius: 5px;
  cursor: pointer;
  &:hover {
    background-color: #5a6268;
  }
`;

export const SuccessButton = styled(CancelButton)`
  background-color: #007bff;
  &:hover {
    background-color: #0056b3;
  }
`;

export const DefaultButton = styled.button`
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  font-size: 14px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #0056b3;
  }

  &:focus {
    outline: none;
  }

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`;

export const DottedBorderButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 20px;
  background-color: #ffffff;
  color: black;
  font-size: 14px;
  border: .13rem dotted #292929;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #f0f0f0;
  }

  &:focus {
    outline: none;
  }

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`;

export function DottedBorderButtonWithLabel({ label, icon = null, ...props }) {
  const { children, ...buttonProps } = props;

  return (
    <div style={{ margin: 0, padding: 0 }}>
      <p style={{ fontSize: '14px', marginBottom: '5px' }}>{label}</p>
      <DottedBorderButton {...buttonProps}>
        {icon && <span style={{ display: 'inline-flex' }}>{icon}</span>}
        {children}
      </DottedBorderButton>
    </div>
  );
}

export const DefaultButtonSmall = styled.button`
  padding: 10px 10px;
  background-color: #007bff;
  color: white;
  font-size: 14px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-top:6px;
  

  &:hover {
    background-color: #0056b3;
  }

  &:focus {
    outline: none;
  }

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`;